import React from 'react';
import { formatBytes } from '../../utilities/format';

interface LargeFileWarningProps {
  // Wording mirrors Angular: 'text' or 'PDF'.
  label: 'text' | 'PDF';
  bytes: number;
  downloadUrl?: string;
  /** MANAGE_DOWNLOADS: without it, download shows disabled (matches PdfViewer). */
  canDownload?: boolean;
  onDownloaded?: () => void;
  onShow: () => void;
}

const TEST_IDS = {
  text: { showTestId: 'viewer-show-large-text-btn', downloadTestId: 'viewer-download-text-btn' },
  PDF: { showTestId: 'viewer-show-large-pdf-btn', downloadTestId: 'viewer-download-pdf-btn' },
};

export default function LargeFileWarning({ label, bytes, downloadUrl, canDownload = true, onShow, onDownloaded }: LargeFileWarningProps) {
  const title = label.charAt(0).toUpperCase() + label.slice(1);
  const { showTestId, downloadTestId } = TEST_IDS[label];
  return (
    <div style={{ padding: '.5in' }}>
      <div className="alert alert-warning alert-block">
        <h4>Large {title} Warning</h4>
        <p>This document contains {formatBytes(bytes)} of {label}</p>
      </div>
      <button type="button" className="btn btn-primary" onClick={onShow} data-testid={showTestId}>
        Display {label}
      </button>
      {downloadUrl && (canDownload ? (
        <a href={downloadUrl} download className="btn btn-default" style={{ marginLeft: 4 }} onClick={onDownloaded} data-testid={downloadTestId}>
          Download {label}
        </a>
      ) : (
        <button
          type="button"
          className="btn btn-default"
          style={{ marginLeft: 4 }}
          title="Downloading requires the Manage Downloads permission"
          disabled
          data-testid={downloadTestId}
        >
          Download {label}
        </button>
      ))}
    </div>
  );
}
